var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 373,
    height: 117,
    viewBox: "0 0 373 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_1505",
    x: 0,
    y: 0,
    width: 373,
    height: 117,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12799",
    "data-name": "Group 12799",
    transform: "translate(1007 -10458)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -1007, 10458)",
    filter: "url(#Rectangle_1505)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1505-2",
    "data-name": "Rectangle 1505",
    width: 355,
    height: 99,
    rx: 49.5,
    transform: "translate(9 6)",
    fill: "#fdeebe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12798",
    "data-name": "Group 12798"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_391",
    "data-name": "Ellipse 391",
    transform: "translate(-985 10478)",
    fill: "#f6db87",
    stroke: "#fa7272",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_392",
    "data-name": "Ellipse 392",
    transform: "translate(-899 10478)",
    fill: "#f6db87",
    stroke: "#fa7272",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_393",
    "data-name": "Ellipse 393",
    transform: "translate(-813 10478)",
    fill: "#f6db87",
    stroke: "#fa7272",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_394",
    "data-name": "Ellipse 394",
    transform: "translate(-727 10478)",
    fill: "#f6db87",
    stroke: "#fa7272",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 35.5,
    r: 35,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "photo",
    transform: "translate(-969.25 10493.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4397",
    "data-name": "Path 4397",
    d: "M36.5,32.777V6.722A3.733,3.733,0,0,0,32.777,3H6.722A3.733,3.733,0,0,0,3,6.722V32.777A3.733,3.733,0,0,0,6.722,36.5H32.777A3.733,3.733,0,0,0,36.5,32.777ZM13.98,23.434l3.908,4.708,5.769-7.426a.934.934,0,0,1,1.489.019l6.532,8.71a.93.93,0,0,1-.744,1.489H8.62a.927.927,0,0,1-.726-1.507l4.634-5.955A.918.918,0,0,1,13.98,23.434Z",
    transform: "translate(0 0)",
    fill: "#4c5b71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2035",
    "data-name": "Group 2035",
    transform: "translate(-278.269 10328.84)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3755",
    "data-name": "Path 3755",
    d: "M-515.98,184.654a16.758,16.758,0,0,1,16.754-16.744,16.756,16.756,0,0,1,16.745,16.754,16.758,16.758,0,0,1-16.791,16.745A16.761,16.761,0,0,1-515.98,184.654Zm6.811.017a9.95,9.95,0,0,0,9.923,9.926,9.948,9.948,0,0,0,9.953-9.934,9.946,9.946,0,0,0-9.942-9.943A9.946,9.946,0,0,0-509.169,184.671Zm9.073,11.6a11.677,11.677,0,0,1-6.979-3.005l-2.409,2.411a15,15,0,0,0,9.388,4Zm9.46-19.459a11.781,11.781,0,0,1,2.091,3.23,11.807,11.807,0,0,1,.924,3.748h3.413a15,15,0,0,0-4.014-9.388Zm-1.006,16.681a11.614,11.614,0,0,1-6.715,2.778v3.393a14.6,14.6,0,0,0,9.109-3.784Zm-22.6-9.7h3.4a11.591,11.591,0,0,1,2.756-6.694l-2.4-2.4A14.729,14.729,0,0,0-514.239,183.792Zm7.466-8a11.66,11.66,0,0,1,6.664-2.743v-3.411a14.988,14.988,0,0,0-9.079,3.742Zm18.836,18.813a14.984,14.984,0,0,0,3.726-9.076h-3.414a11.622,11.622,0,0,1-2.739,6.676Zm-10.426-21.553a11.631,11.631,0,0,1,6.428,2.529l2.41-2.425a14.946,14.946,0,0,0-8.838-3.517ZM-514.25,185.53a14.963,14.963,0,0,0,3.527,8.844l2.417-2.42a11.65,11.65,0,0,1-2.534-6.424Z",
    transform: "translate(0)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3756",
    "data-name": "Path 3756",
    d: "M-388.225,291.568c1.018.7,2.03,1.373,3.015,2.085a1.217,1.217,0,0,1,.45.667c.1.485-.233.862-.774.95-.815.132-1.633.248-2.449.371-.338.051-.68.088-1.013.159a.3.3,0,0,0-.177.226c.057.979.132,1.957.2,2.936.015.212.029.424.042.637a.811.811,0,0,1-.48.835.814.814,0,0,1-.976-.175l-2.531-2.332c-.06-.056-.123-.108-.218-.193-.445.407-.887.809-1.326,1.214s-.883.822-1.326,1.232a.872.872,0,0,1-1.088.247.9.9,0,0,1-.453-.989c.09-1.1.154-2.193.239-3.288.019-.247-.037-.343-.31-.379-1.111-.146-2.218-.324-3.325-.5a.85.85,0,0,1-.782-.665.844.844,0,0,1,.433-.96q1.343-.924,2.689-1.842c.106-.073.209-.15.337-.242l-1.1-1.913c-.247-.43-.49-.862-.74-1.29a.849.849,0,0,1,.031-1.025.844.844,0,0,1,.991-.268c1.059.324,2.12.641,3.174.983.28.091.407.059.517-.237.382-1.027.8-2.04,1.2-3.063a.911.911,0,0,1,.831-.662.893.893,0,0,1,.857.672c.412,1.041.825,2.082,1.226,3.128.08.208.162.259.388.187,1.044-.333,2.1-.633,3.142-.966a.918.918,0,0,1,1.123.232.934.934,0,0,1-.042,1.15C-387.045,289.507-387.628,290.531-388.225,291.568Zm-4.9-4.288c-.05.113-.066.144-.079.177q-.358.9-.716,1.808c-.3.752-.627.909-1.4.669l-2.049-.631c.415.725.795,1.377,1.163,2.034a.848.848,0,0,1-.277,1.235c-.278.2-.565.387-.848.581l-1.08.744c.795.12,1.489.228,2.185.327a.9.9,0,0,1,.91,1.065c0,.177-.028.353-.04.53-.037.554-.073,1.108-.116,1.754l1.615-1.5a.894.894,0,0,1,1.447-.005c.53.48,1.055.967,1.635,1.5-.053-.8-.1-1.51-.146-2.226-.045-.735.212-1.023.954-1.124.681-.093,1.359-.207,2.127-.325-.641-.441-1.2-.828-1.764-1.213-.681-.467-.76-.8-.353-1.509l1.072-1.866-2.064.632c-.753.231-1.092.07-1.381-.659Z",
    transform: "translate(-106.325 -107.93)",
    fill: "#4c5b71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2036",
    "data-name": "Group 2036",
    transform: "translate(-462.16 10260.196)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    d: "M-412.564,268.031l10.185,10.206a1.851,1.851,0,0,1,.23-.374q2.266-2.281,4.545-4.55c.471-.47.761-.471,1.228,0q3.275,3.274,6.549,6.55c.47.471.47.771,0,1.225a11.135,11.135,0,0,1-6.385,3.017,16.581,16.581,0,0,1-11.307-2.69,24.81,24.81,0,0,1-9.351-10.256,16.581,16.581,0,0,1-1.735-7.359,11.672,11.672,0,0,1,3.184-8.348c.425-.444.737-.449,1.166-.021q3.3,3.3,6.606,6.607c.448.448.445.741-.011,1.2q-2.273,2.275-4.551,4.544A2.738,2.738,0,0,1-412.564,268.031Z",
    transform: "translate(0 -14.191)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_427",
    "data-name": "Group 427",
    transform: "translate(-406.153 236.554)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    d: "M-253.168,325.371a4.67,4.67,0,0,0-1.578,2.188.373.373,0,0,1-.4.269,5.211,5.211,0,0,0-1.322.2,1.764,1.764,0,0,0-1.251,1.718,4.162,4.162,0,0,0,.284,2.1.609.609,0,0,1,.028.132c-.919.319-1.078,1.129-1.23,1.929-.1.517-.145,1.044-.212,1.567-.016.125-.025.227-.2.227q-2.734-.005-5.469,0a1.083,1.083,0,0,1-.135-.018,1.146,1.146,0,0,1-.014-.152c.066-1.813.1-3.629.213-5.438a17.754,17.754,0,0,1,.9-4.874,4.742,4.742,0,0,1,1.385-2.194,2.188,2.188,0,0,1,1.386-.511,1.686,1.686,0,0,1,.636.134,4.753,4.753,0,0,0,3.979.056,1.55,1.55,0,0,1,2.072.54,5.283,5.283,0,0,1,.451.882C-253.472,324.529-253.332,324.938-253.168,325.371Z",
    transform: "translate(264.667 -313.918)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M-145.019,364.5h-8.993c-.159-.681-.286-1.33-.465-1.964a2.637,2.637,0,0,0-1.077-1.641,2.3,2.3,0,0,1,.08-.233,5.04,5.04,0,0,0,.306-2.256,1.711,1.711,0,0,0-.8-1.377,4.771,4.771,0,0,1,1.363-2.058,1.931,1.931,0,0,1,1.2-.434,1.2,1.2,0,0,1,.467.1,4.612,4.612,0,0,0,3.4.186.533.533,0,0,0,.118-.048,1.344,1.344,0,0,1,1.119-.189,2.3,2.3,0,0,1,1.189.75,6.615,6.615,0,0,1,1.267,2.645,21.258,21.258,0,0,1,.671,4.147C-145.114,362.9-145.072,363.675-145.019,364.5Z",
    transform: "translate(167.102 -342.662)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    d: "M-226.965,246.941a4.138,4.138,0,0,1-2.27-.629,2.877,2.877,0,0,1-1.237-2.653,21.745,21.745,0,0,1,.289-2.863,2.849,2.849,0,0,1,2.443-2.221,4.637,4.637,0,0,1,2.372.332,2.907,2.907,0,0,1,1.8,3.5,19.634,19.634,0,0,1-.665,2.348,2.967,2.967,0,0,1-2.045,2.07A5.689,5.689,0,0,1-226.965,246.941Z",
    transform: "translate(233.977 -238.539)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3801",
    "data-name": "Path 3801",
    d: "M-145.6,286.99c.209-.234.418-.467.626-.7a1.123,1.123,0,0,0,.236-1.162,5.372,5.372,0,0,1-.289-2.107,2.839,2.839,0,0,1,2.429-2.6,3.038,3.038,0,0,1,3.61,2.873,7.5,7.5,0,0,1,.041,1.121,1.19,1.19,0,0,0,.558,1.1c.239.161.483.313.758.492-.363.1-.7.2-1.036.289a2.8,2.8,0,0,0-1.128.552,3.4,3.4,0,0,1-1.712.8,3.415,3.415,0,0,1-2.014-.411,1.512,1.512,0,0,0-.576-.16c-.5-.022-1-.007-1.5-.007Z",
    transform: "translate(157.792 -276.08)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3802",
    "data-name": "Path 3802",
    d: "M-198,426.484c.135-.683.212-1.319.393-1.924a1.126,1.126,0,0,1,1.227-.9c.232.024.456.161.686.169a2.623,2.623,0,0,0,.921-.094,1.064,1.064,0,0,1,1.264.364,3.082,3.082,0,0,1,.48,1.539c.029.269.029.54.044.849Z",
    transform: "translate(204.828 -404.693)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3803",
    "data-name": "Path 3803",
    d: "M-189.219,384.44a1.572,1.572,0,0,1,.5-1.456,2.144,2.144,0,0,1,2.392-.016,1.248,1.248,0,0,1,.507,1.039,10.291,10.291,0,0,1-.109,1.319,1.453,1.453,0,0,1-1.638,1.265,1.467,1.467,0,0,1-1.567-1.418C-189.171,384.93-189.191,384.684-189.219,384.44Z",
    transform: "translate(196.953 -367.858)",
    fill: "#4c5b71"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_2652",
    "data-name": "Group 2652",
    transform: "translate(-142.461 10352.631)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3757",
    "data-name": "Path 3757",
    d: "M-474.472,410.62a1.923,1.923,0,0,0-.189-2.493,1.923,1.923,0,0,0-2.589-.145c-.867-1.18-1.537-1.42-2.723-.957-.044-.084-.09-.17-.135-.257a1.854,1.854,0,0,0-2.417-.908.329.329,0,0,1-.444-.1c-.418-.516-.839-1.03-1.241-1.558a.349.349,0,0,1,.012-.322q2.063-2.923,4.147-5.832a.4.4,0,0,1,.235-.171,13.331,13.331,0,0,1,3.3.079c-.423.337-.776.64-1.152.913a1.641,1.641,0,0,0-.715,1.474c.023.837,0,1.675.006,2.513,0,.738.428,1.071,1.138.89a3.359,3.359,0,0,0,2.539-2.368.4.4,0,0,1,.482-.337c.539.021,1.079.015,1.618,0a.394.394,0,0,1,.4.236,4.951,4.951,0,0,0,1.574,1.836,1.382,1.382,0,0,0,.666.206c.687.029,1.377.007,2.065.027a1,1,0,0,1,.507.155q3,2.039,5.991,4.1a1.06,1.06,0,0,1,.365,1.568,1.081,1.081,0,0,1-1.581.182q-2.7-1.9-5.392-3.815c-.065-.046-.129-.1-.2-.137a.517.517,0,0,0-.736.086c-.166.233-.1.49.194.7.673.479,1.35.951,2.025,1.426.741.521,1.484,1.04,2.222,1.566a1.02,1.02,0,0,1,.432,1.115.989.989,0,0,1-.784.778,1.109,1.109,0,0,1-.963-.248q-1.915-1.373-3.835-2.74c-.037-.027-.073-.055-.111-.081-.312-.215-.586-.2-.757.035s-.106.509.2.729c.483.349.971.692,1.455,1.041.428.308.86.611,1.276.935a.986.986,0,0,1,.4,1,1.042,1.042,0,0,1-1.671.67c-.909-.62-1.8-1.262-2.7-1.9-.43-.3-.7-.326-.9-.064s-.095.526.336.829c.234.165.473.324.7.5a.973.973,0,0,1,.224,1.4,1,1,0,0,1-1.381.184.649.649,0,0,1-.339-.728,1.832,1.832,0,0,0-1.207-1.886C-474.237,410.7-474.354,410.663-474.472,410.62Z",
    transform: "translate(-76.726 -236.222)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3758",
    "data-name": "Path 3758",
    d: "M-416.053,151.279c0-1.3.005-2.593,0-3.89a.361.361,0,0,1,.264-.4c2.25-.939,4.494-1.892,6.744-2.83a.644.644,0,0,1,.448,0c2.262.941,4.518,1.9,6.78,2.84a.322.322,0,0,1,.226.358c-.006,2.582,0,5.164-.009,7.745a3.984,3.984,0,0,1-.737,2.114,12.977,12.977,0,0,1-2.867,3.041.624.624,0,0,1-.35.092q-2.68.111-5.361.21a.126.126,0,0,0-.034,0,1.685,1.685,0,0,1-1.8-.536,14.25,14.25,0,0,1-2.6-2.869,4.35,4.35,0,0,1-.706-2.471C-416.03,153.551-416.053,152.415-416.053,151.279Zm7.232,6.425a5.1,5.1,0,0,0,5.1-5.125,5.107,5.107,0,0,0-5.125-5.1,5.111,5.111,0,0,0-5.087,5.11A5.109,5.109,0,0,0-408.821,157.7Z",
    transform: "translate(-140.214 0)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3759",
    "data-name": "Path 3759",
    d: "M-384.943,400.276c0-.917-.011-1.812.011-2.705a.667.667,0,0,1,.248-.42c.68-.563,1.357-1.134,2.078-1.641a1.99,1.99,0,0,1,.911-.212,41.082,41.082,0,0,1,8.037-.025,5.1,5.1,0,0,0,.787.064,1.139,1.139,0,0,1,1.076.621c1.236,1.78,2.5,3.539,3.768,5.3a.392.392,0,0,1,0,.568c-.416.488-.821.985-1.23,1.478-.16.193-.306.192-.522.042q-2.372-1.647-4.768-3.261a1.215,1.215,0,0,0-.6-.186c-.7-.032-1.4-.039-2.1-.036a.8.8,0,0,1-.7-.3c-.381-.512-.772-1.021-1.1-1.565a.763.763,0,0,0-.733-.445c-.837.014-1.675,0-2.512,0-.521,0-.64.1-.734.611A2.5,2.5,0,0,1-384.943,400.276Z",
    transform: "translate(-169.187 -233.687)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3760",
    "data-name": "Path 3760",
    d: "M-189.312,353.59l6.1,7.005-4.089,2.772-5.369-7.539Z",
    transform: "translate(-348.226 -195.046)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3761",
    "data-name": "Path 3761",
    d: "M-560.54,353.578l3.353,2.236-5.369,7.54-4.089-2.77Z",
    transform: "translate(0 -195.035)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3762",
    "data-name": "Path 3762",
    d: "M-402.525,555.7a3.011,3.011,0,0,1,.259-.508q.8-1.035,1.62-2.05a.894.894,0,0,1,1.311-.148.9.9,0,0,1,.186,1.309c-.54.712-1.1,1.41-1.661,2.105a.886.886,0,0,1-1.057.261A1.107,1.107,0,0,1-402.525,555.7Z",
    transform: "translate(-152.818 -380.517)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3763",
    "data-name": "Path 3763",
    d: "M-432.693,542.9a2.952,2.952,0,0,1-.246.545c-.28.391-.582.766-.886,1.138a.934.934,0,0,1-1.313.19.921.921,0,0,1-.2-1.334c.3-.405.615-.8.936-1.186a.867.867,0,0,1,1.021-.266A1.08,1.08,0,0,1-432.693,542.9Z",
    transform: "translate(-122.08 -370.408)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3764",
    "data-name": "Path 3764",
    d: "M-365.093,598.225a1.713,1.713,0,0,1,.827-1.1.818.818,0,0,1,.964.08.912.912,0,0,1,.23,1.324,4.593,4.593,0,0,1-.389.479.885.885,0,0,1-1,.242A1.022,1.022,0,0,1-365.093,598.225Z",
    transform: "translate(-187.672 -421.696)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3765",
    "data-name": "Path 3765",
    d: "M-464.136,528.4a.912.912,0,0,1-.954-.942,1.288,1.288,0,0,1,1.13-1.176.946.946,0,0,1,.938.939A1.24,1.24,0,0,1-464.136,528.4Z",
    transform: "translate(-94.562 -355.846)",
    fill: "#4c5b71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3766",
    "data-name": "Path 3766",
    d: "M-364.081,217.859a3.925,3.925,0,0,1-3.88-4.118,3.934,3.934,0,0,1,4.106-3.751,3.932,3.932,0,0,1,3.743,4.08A3.928,3.928,0,0,1-364.081,217.859Zm-.65-2.869c-.29-.322-.531-.615-.8-.879a.553.553,0,0,0-.851,0,.574.574,0,0,0,.036.832q.586.606,1.193,1.192a.568.568,0,0,0,.859.025q1.547-1.521,3.068-3.067a.561.561,0,0,0,0-.83.573.573,0,0,0-.832.02c-.576.56-1.141,1.131-1.707,1.7C-364.07,214.294-364.367,214.611-364.731,214.99Z",
    transform: "translate(-185.001 -61.335)",
    fill: "#4c5b71"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.4447467fa1d39c7d9e859d8eb09387c0.svg";
export { ForwardRef as ReactComponent };